// agencySelectedCreatorContext.js
import React, { createContext, useContext } from 'react';

const CreatorContext = createContext(undefined); // Add default value

export const useCreator = () => {
  const context = useContext(CreatorContext);
  // Return undefined if no provider (instead of throwing)
  return context || { creatorData: undefined, refetch: undefined };
};

export function CreatorProvider({ value, children }) {
  return <CreatorContext.Provider value={value}>{children}</CreatorContext.Provider>;
}